import React from "react"
import { breakpoints, color } from "../../../utils/style"
import IcomoonIcon from "../../shared/IcomoonIcon"
import Img from "gatsby-image"
import styled from "@emotion/styled"
import GetWindowWidth from "../../shared/GetWindowWidth"

const ContactsWrap = styled("div")`
  .description {
    font-size: 15px;
    line-height: 24px;
    margin-bottom: 32px;
  }
  .top-contact-block {
    display: flex;
    flex-flow: row wrap;
    .col {
      flex-basis: 50%;
    }
  }
  .item-wrap {
    display: flex;
    justify-content: center;
    margin-top: -25px;
  }
  .item {
    padding: 22px;
    text-align: center;
    border-radius: 4px;
    color: ${color.white};
    text-decoration: none;
    cursor: pointer;
    transition: all 0.15s;
    svg {
      margin-bottom: 16px;
    }
    &:hover {
      background: ${color.pink};
    }
  }
  .small-text {
    font-size: 12px;
    line-height: 18px;
    opacity: 0.8;
  }
  .bottom-banner {
    width: 100%;
    max-width: 760px;
    float: right;
  }
  .clearfix {
    clear: both;
  }
  @media (max-width: ${breakpoints.md}) {
    .top-contact-block {
      .col {
        flex-basis: 100%;
      }
    }
    .item-wrap {
      margin: 24px 0;
    }
    .item {
      background: ${color.pink};
      border-radius: 0;
    }
    .small-text {
      display: none;
    }
  }
  @media (max-width: ${breakpoints.sm}) {
    .item-wrap {
      background: ${color.pink};
    }
    .item {
      flex-basis: 33.333%;
      padding: 16px 10px;
      font-size: 12px;
      line-height: 18px;
      svg {
        margin-bottom: 8px;
      }
    }
    .bottom-banner {
      display: none;
    }
  }
`

const Contacts = ({ contact_text, img }) => {
  const windowWidth = GetWindowWidth()
  const isDesktop = windowWidth > 600

  const CHAT_SCRIPT_URL = "https://cdn.respond.io/webchat/widget/widget.js?cId=3e3e44cc1f52688b8d0a9e227eb8559";

  const showHideChat = () => {
    const head = document.head;
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = CHAT_SCRIPT_URL;
    script.id = "respondio__widget";

    const chatScript = document.getElementById("respondio__widget");
    if (chatScript === null) {
      head.appendChild(script);
    }
  }

  return (
    <ContactsWrap>
      <div className="top-contact-block">
        <div className="col">
          {contact_text && <p className="description">{contact_text}</p>}
          <a href="/register/?register_type=onsitegames" className="button pink-button">
            918KISS
          </a>
        </div>
        <div className="col">
          <div className="item-wrap">
            <a href={`tel:${process.env.PHONE_TO_CALL}`} className="item">
              <div>
                <IcomoonIcon
                  icon="call-answer"
                  color={color.white}
                  size={isDesktop ? 52 : 34}
                />
              </div>
              <div>
                <span className="small-text">Call Center</span>
              </div>
              <div>
                <span>{process.env.PHONE_TO_DISPLAY}</span>
              </div>
            </a>
            <a
              className="item"
              href={process.env.LINE_ID_EXT}
              target="_blank"
              rel="noreferrer noopener"
            >
              <div>
                <IcomoonIcon
                  icon="line"
                  color={color.white}
                  size={isDesktop ? 52 : 34}
                />
              </div>
              <div>
                <span className="small-text">Line@</span>
              </div>
              <div>
                <span> {process.env.LINE_ID_TEXT}</span>
              </div>
            </a>

            <span
              className="item"
              role="button"
              tabIndex={0}
              onClick={() => showHideChat()}
              onKeyDown={() => showHideChat()}
            >
              <div>
                <IcomoonIcon
                  icon="chat-2"
                  color={color.white}
                  size={isDesktop ? 52 : 34}
                />
              </div>
              <div>
                <span className="small-text">LIVE CHAT</span>
              </div>
              <div>
                <span>24/7 Support</span>
              </div>
            </span>
          </div>
        </div>
      </div>
      <div className="bottom-banner">
        <Img
          fluid={img.localFile.childImageSharp.fluid}
          alt={img.alt_text ? img.alt_text : "top banner 1"}
          fadeIn={false}
          loading="eager"
        />
      </div>
      <div className="clearfix"/>
    </ContactsWrap>
  )
}

export default Contacts
